import { GetTicketQueryParams } from "../types";
import { getOscConfig } from "./oneSupportCenterEnv";

const { ticketingApiEndpoint } = getOscConfig();

const routes = {
  tickets: "/v1/tickets",
};

export const ticketingRoutes = {
  getTicketField: (fieldId: string): string =>
    `${routes.tickets}/field/${fieldId}`,
  getTicketById: (ticketId: string): string =>
    `${routes.tickets}/${ticketId}?include=users`,
  getTicketHistory: (queryParams: GetTicketQueryParams): string =>
    `${routes.tickets}?q=${JSON.stringify(queryParams)}`,
  createGatedTicket: `${routes.tickets}`,
  createUngatedTicket: `${routes.tickets}/ungated`,
  updateTicket: (ticketId: string): string => `${routes.tickets}/${ticketId}`,
};

export const ticketingBaseUrl = ticketingApiEndpoint;
